import React from 'react';
import TransactionsDetailBarV2 from './components/TransactionsDetailBarV2';
import TransactionsDetailBar from './components/TransactionsDetailBar';
import PerformanceCardSkeleton from '../../components/PerformanceCardSkeleton';
import EntityCardSkeleton from '../../components/EntityCardSkeleton';

// Full-tab shimmer — Performance card + the 3 entity cards Transactions V1/V2
// render below it (transactions / creatives / publishers). Keeps the
// loading visual proportional to the final layout so users see "4 cards
// are coming" rather than one floating spinner.
const TabSkeleton = () => (
  <>
    <PerformanceCardSkeleton />
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
  </>
);

const TransactionsTab = ({
  colStyle,
  selectedCampaign,
  chartsLoading,
  campaignOrder,
  chartData,
  byTransactionsRangeDate,
  setByTransactionsRangeDate,
  dataTransactionsRangeDate,
  setDataTransactionsRangeDate,
  byCampaignRangeDate,
  setByCampaignRangeDate,
  dataCampaignRangeDate,
  setDataCampaignRangeDate,
  dataAttributionWindow,
  setDataAttributionWindow,
  transactionTarget,
  dateTrue,
  setDateTrue,
  priceVisible,
  reportName,
  transactionsTable,
  transactionsTableLoading,
  attributionWindow,
  setCurrentIdx,
  setCurrentStartEndDate,
  setAttributionWindow,
  currentUser,
  currencyFormat,
  embeddableConfig,
  attributionMethod,
  setAttributionMethod,
}) => {
  if (chartsLoading || chartsLoading === undefined || chartData === null) {
    return <TabSkeleton />;
  }
  // `.mjl-ds` wrapper opts this whole tab into v2 AntD overrides + shared
  // design-system compositions. Both internal paths (V2 and legacy V1 shape
  // via TransactionsDetailBar) render inside the same scope.
  return (
    <div className="mjl-ds campaign-transactions-v1">
      {chartData && chartData.byDate ? (
        <TransactionsDetailBarV2
          selectedCampaign={selectedCampaign}
          chartDataRaw={chartData}
          campaignOrder={campaignOrder}
          transactionTarget={transactionTarget}
          dateTrue={dateTrue}
          priceVisible={priceVisible}
          reportName={reportName}
          setDataAttributionWindow={setDataAttributionWindow}
          transactionsTable={transactionsTable}
          transactionsTableLoading={transactionsTableLoading}
          setCurrentIdx={setCurrentIdx}
          setCurrentStartEndDate={setCurrentStartEndDate}
          attributionWindow={attributionWindow}
          setAttributionWindow={setAttributionWindow}
          currentUser={currentUser}
          currencyFormat={currencyFormat}
          attributionMethod={attributionMethod}
          setAttributionMethod={setAttributionMethod}
        />
      ) : (
        <TransactionsDetailBar
          colStyle={colStyle}
          selectedCampaign={selectedCampaign}
          campaignOrder={campaignOrder}
          chartData={chartData}
          byTransactionsRangeDate={byTransactionsRangeDate}
          setByTransactionsRangeDate={setByTransactionsRangeDate}
          dataTransactionsRangeDate={dataTransactionsRangeDate}
          setDataTransactionsRangeDate={setDataTransactionsRangeDate}
          byCampaignRangeDate={byCampaignRangeDate}
          setByCampaignRangeDate={setByCampaignRangeDate}
          dataCampaignRangeDate={dataCampaignRangeDate}
          dataAttributionWindow={dataAttributionWindow}
          setDataAttributionWindow={setDataAttributionWindow}
          setDataCampaignRangeDate={setDataCampaignRangeDate}
          transactionTarget={transactionTarget}
          dateTrue={dateTrue}
          setDateTrue={setDateTrue}
          priceVisible={priceVisible}
          reportName={reportName}
        />
      )}
    </div>
  );
};

export default TransactionsTab;
